import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import CreateOppPlayerOverlay from "./components/CreateOppPlayer";
import OppPlayerCard from "./components/OppPlayerCard";
import { useHistory, useParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { getOppTeamPlayers } from "../../services/player.services.js";
import { getOneOppTeam } from "../../services/team.services.js";
import CreateFastOppPlayerOverlay from "./components/FastAddOppPlayer.jsx";
import EditOppPlayerOverlay from "./components/EditOppPlayer.jsx";

import "./opproster.css";
import UserSidebar from "../../../components/userSiderbar/userSidebar.jsx";

const OppRoster = (props) => {
  const user = useSelector((state) => state.auth.user);
  const team_id = props.location?.state?.team_id;

  const history = useHistory();
  const [teamData, setTeamData] = useState(null);
  const [playerData, setPlayerData] = useState(null);
  const [displayPhone, setDisplayPhone] = useState("");
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [fastAddVisible, setFastAddVisible] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);

  const toggleAddPlayer = () => setVisible(!visible);
  const goBackHandler = () => history.goBack();

  const handleGetOppTeam = async () => {
    try {
      setLoading(true);
      const response = await getOneOppTeam(team_id, user?.token);
      setTeamData(response.data);
    } catch (err) {
      console.error("Error in fetching team details:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleGetTeamPlayers = async () => {
    try {
      setLoading(true);
      const response = await getOppTeamPlayers(team_id, user?.token);
      setPlayerData(response.data);
    } catch (error) {
      console.error("Error in fetching players:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
    console.log("Team ID:", team_id);
    console.log("User Token:", user?.token);
  };

  useEffect(() => {
    handleGetTeamPlayers();
  }, [teamData]);

  useEffect(() => {
    handleGetOppTeam();
  }, []);

  useEffect(() => {
    let phoneLength = teamData?.coachCell.length;
    let formattedNumber = "";
    if (phoneLength === 0) {
      formattedNumber = "none";
    } else if (phoneLength < 4) {
      formattedNumber = teamData?.coachCell;
    } else if (phoneLength < 7) {
      formattedNumber = `(${teamData?.coachCell.slice(
        0,
        3
      )}) ${teamData?.coachCell.slice(3)}`;
    } else {
      formattedNumber = `(${teamData?.coachCell.slice(
        0,
        3
      )}) ${teamData?.coachCell.slice(3, 6)}-${teamData?.coachCell.slice(
        6,
        12
      )}`;
    }
    setDisplayPhone(formattedNumber);
  }, [teamData]);

  const playersArrangedData = React.useMemo(() => {
    return playerData?.sort((a, b) => a.playerNumber - b.playerNumber);
  }, [playerData]);

  return (
    <>
      <div className="myTeamMain">
        <UserSidebar />
        {/* <div className="backBtn">
          <button className="actionButtonBack" onClick={goBackHandler}>
            &larr;
          </button>
        </div> */}
        <div className="detailsScreen">
          {/* <h1 className="headerTxtMyTeam" style={{ color: 'white' }}>OPPONENT DETAILS</h1> */}
          <div className="teamAndRosterContainer">
            <div className="teamDataViewOpp">
              <div onClick={() =>
                history.push(`/editoppteam/${teamData?._id}`, {
                  handleGetOppTeam,
                })
              } className="rowTeamName">
                <p className="teamNameTxt" style={{ color: '#d4af37' }} >
                  {teamData?.teamName}
                </p>
                <button onClick={() =>
                  history.push(`/editoppteam/${teamData?._id}`, {
                    team_id: teamData?._id,
                  })
                } className="editBtnOpp">
                  <EditIcon style={{ fontSize: 16 }} />
                </button>
              </div>
              <div className="line" />
              <div className="infoRow">
                <p className="nameTxtMyTeam">
                  Nick Name :{" "}
                  {teamData?.teamNickName || "none"}
                </p>
                <p className="nameTxtMyTeam">
                  Coach Name :{" "}
                  {teamData?.coachName || "none"}
                </p>
                <p className="nameTxtMyTeam">Coach Cell : {displayPhone}</p>
                <p className="nameTxtMyTeam">
                  Coach Email :{" "}
                  {teamData?.coachEmail || "none"}
                </p>
                <p className="nameTxtMyTeam">
                  Conference :{" "}
                  {teamData?.isConference ? "Yes" : "No"}
                </p>
              </div>
            </div>
            <div className="rosterView">
              <div className="row2">
                <p className="rosterHeadingOpp">ROSTER</p>
                <button onClick={toggleAddPlayer} className="addPlyrBtn">
                  <AddCircleIcon style={{ fontSize: 16, color: 'red', marginRight: '2px' }} />
                  <p style={{ fontSize: "15px", fontWeight: '700', borderBottom: '2px solid red' }}>Add Player</p>
                </button>
                <button onClick={() => setFastAddVisible(true)} className="addPlyrBtn">
                  <AddCircleIcon style={{ fontSize: 16, color: 'red', marginRight: '2px' }} />
                  <p style={{ fontSize: "15px", fontWeight: '700', borderBottom: '2px solid red' }}>Quick Add</p>
                </button>
              </div>

              {visible && (
                <CreateOppPlayerOverlay
                  isVisible={visible}
                  onClose={() => setVisible(false)}
                  teamId={team_id}
                  handleGetPlayers={handleGetTeamPlayers}
                />
              )}
              {fastAddVisible && <CreateFastOppPlayerOverlay
                isVisible={fastAddVisible}
                onClose={() => setFastAddVisible(false)}
                oid={team_id}
                refreshPlayers={handleGetTeamPlayers}
                playerData={playerData}
              />}

              {loading && <p style={{ color: 'red', fontWeight: '700', display: 'flex', justifyContent: "center", }}>Loading...</p>}
              {/* <div className="TMdataRow">
              <p className="playerNameTxtMyTeam" style={{ color: 'white', fontWeight: '700', display: 'flex', justifyContent: "center", marginTop: '5px' }}>TEAM STAT</p>
            </div> */}

              <div className="rosterTableWrapper">
                <table className="rosterTable">
                  <thead>
                    <div className="rosterHeader">
                      <th>HOME</th>
                      <th>PLAYER</th>
                      <th>AWAY</th>
                    </div>
                  </thead>
                  {/* </thead> */}
<tbody>
                  {playersArrangedData &&
                    playersArrangedData.map((v, i) => (
                      <tr key={i}>
                        <OppPlayerCard
                          v={v}
                          onSelectPlayer={setSelectedPlayer}
                        />
                      </tr>
                    ))}
                </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
         {selectedPlayer && (
        <EditOppPlayerOverlay
          onBackdropPress={() => setSelectedPlayer(null)}
          isVisible={!!selectedPlayer}
          handleGetPlayers={handleGetTeamPlayers}
          data={selectedPlayer}
          navigation={history}
          playerId={selectedPlayer?._id}
        />
      )}

        {/* {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p>Connect to the internet and try again!</p>
            ) : (
              playersArrangedData?.map(player => (
                <OppPlayerCard
                  key={player._id}
                  player={player}
                  teamId={team_id}
                  handleGetPlayers={handleGetTeamPlayers}
                  navigation={history} 
                />
              ))
            )} */}
      </div>
    </>
  );
};

export default OppRoster;
